import React from 'react';
import './ZoomControls.scss';

const ZoomControls = ({
  zoomLevel,
  onZoomIn,
  onZoomOut,
  onFitToScreen,
  onZoomChange
}) => {
  return (
    <div className="zoom-controls-bottom">
      <div className="zoom-controls-container">
        {/* Zoom Out Button */}
        <button
          onClick={onZoomOut}
          disabled={zoomLevel <= 50}
          title="Zoom Out"
          className="zoom-btn zoom-out"
        >
          <i className="fa fa-minus"></i>
        </button>

        {/* Zoom Slider */}
        <input
          type="range"
          min="50"
          max="200"
          value={zoomLevel}
          onChange={(e) => onZoomChange(parseInt(e.target.value))}
          className="zoom-slider"
          title={`Zoom: ${zoomLevel}%`}
        />

        {/* Zoom In Button */}
        <button
          onClick={onZoomIn}
          disabled={zoomLevel >= 200}
          title="Zoom In"
          className="zoom-btn zoom-in"
        >
          <i className="fa fa-plus"></i>
        </button>

        {/* Zoom Percentage Display */}
        <span className="zoom-percentage">{zoomLevel}%</span>

        {/* Fit to Screen Button */}
        <button
          onClick={onFitToScreen}
          title="Fit to Screen"
          className="zoom-btn fit-screen"
        >
          <i className="fa fa-expand"></i>
        </button>
      </div>
    </div>
  );
};

export default ZoomControls;
